const spaceLarge = 'var(--spacing-1x, 1rem)'
const spaceXSmall = 'var(--spacing-0-25x, 0.25rem)'
import styled from 'astroturf/react'
import { useSelector } from 'react-redux'
const colorTextSuccess = 'var(--colorTextSuccess, var(--coreColorGreen800))'
const colorTextStandard = 'var(--colorTextStandard, var(--coreColorNeutral900))'
import { CheckCircleIcon } from '@calendly/ui/components/icons'
import { useFlag } from '@calendly/feature-check-react'
import detect from 'detect.js'
import { Loader } from '@calendly/ui/components/loader'
import { TitleText } from '@calendly/ui/components/typography'

import Profile from 'components/profile'
import { GmailConfirmation } from 'components/confirmation/gmail_confirmation'
import PaymentMessage from 'components/confirmation/pages/new_confirmation/payment_message'
import { emailSelector } from 'selectors/invitee'
import { eventSelector } from 'selectors'
import ErrorAlert from 'components/error/alert'
import { useI18n } from 'locales'
import { useConfirmationPageData } from 'components/confirmation/useConfirmationPageData'
import _Header from "confirmation_header-Header.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/confirmation_header.js?styleId=Header";
import _TitleWrapper from "confirmation_header-TitleWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/confirmation_header.js?styleId=TitleWrapper";
import _PaymentMessageWrapper from "confirmation_header-PaymentMessageWrapper.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/confirmation_header.js?styleId=PaymentMessageWrapper";
import _IconContainer from "confirmation_header-IconContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/new_confirmation/confirmation_header.js?styleId=IconContainer";


const Header = /*#__PURE__*/styled('div', null, {
  displayName: "Header",
  styles: _Header
})

const TitleWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "TitleWrapper",
  styles: _TitleWrapper
})

const PaymentMessageWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentMessageWrapper",
  styles: _PaymentMessageWrapper
})

const IconContainer = /*#__PURE__*/styled('div', null, {
  displayName: "IconContainer",
  styles: _IconContainer
})

export const ConfirmationHeader = () => {
  const { i18n } = useI18n()
  const event = useSelector(eventSelector)
  const inviteeEmail = useSelector(emailSelector)
  const { isReschedulingFlow } = useConfirmationPageData()
  const bookingAppRedesign = useFlag('booking_app_redesign', false)
  const sniperLinkFeatureActive = useFlag('sb_sniper_links_feature', false)
  const ua = detect.parse(navigator.userAgent)
  const notIphone = ua.device.name !== 'iPhone'
  const shouldSeeGmailSniperLink = inviteeEmail && inviteeEmail.includes('@gmail.com') && sniperLinkFeatureActive && notIphone

  if (event === undefined) return <Loader />

  if (event === null) {
    return (
      <ErrorAlert
        error={{}}
        buttonClick={() => window.location.reload()}
      />
    )
  }

  const {
    scheduled_profile: {
      avatar_url: avatarUrl,
      logo_url: logoUrl
    }
  } = event

  const titleText = isReschedulingFlow
    ? i18n.t('booking.templates.rescheduled')
    : i18n.t('booking.templates.scheduled')

  return (
    <Header bookingAppRedesign={bookingAppRedesign} data-component="confirmation-header">
      <Profile
        avatar={avatarUrl}
        logoUrl={logoUrl}
      />
      <TitleText level={2} as="h1" size={bookingAppRedesign ? 'medium' : 'large'}>
        <TitleWrapper bookingAppRedesign={bookingAppRedesign}>
          {!bookingAppRedesign && (
            <IconContainer>
              <CheckCircleIcon color={colorTextSuccess} size="large" />
            </IconContainer>
          )}
          {titleText}
        </TitleWrapper>
      </TitleText>
      <PaymentMessageWrapper bookingAppRedesign={bookingAppRedesign}>
        <PaymentMessage />
      </PaymentMessageWrapper>
      {shouldSeeGmailSniperLink && <GmailConfirmation />}
    </Header>
  )
}
